document.addEventListener('DOMContentLoaded', function () {

    // =========================
    // 1. FAST SCROLL (jump)
    // =========================
    function jumpTo(y) {
        window.scrollTo(0, y);
    }

    // =========================
    // 2. SMOOTH FINISH SCROLL
    // =========================
    function smoothScrollTo(y, duration = 350) {
        const start = window.scrollY;
        const diff = y - start;
        let startTime = null;

        const easeOutCubic = t => 1 - Math.pow(1 - t, 3);

        function step(timestamp) {
            if (!startTime) startTime = timestamp;

            const time = timestamp - startTime;
            const progress = Math.min(time / duration, 1);

            const eased = easeOutCubic(progress);

            window.scrollTo(0, start + diff * eased);

            if (time < duration) {
                requestAnimationFrame(step);
            }
        }

        requestAnimationFrame(step);
    }

    // =========================
    // RUN SCROLL (2-step UX)
    // =========================
    window.runScroll = function (el, offset = 0) {

    const targetEl = document.querySelector(el);
    if (!targetEl) return;

    const topbar = document.querySelector('.js-topbar');
    const topbarHeight = topbar ? topbar.offsetHeight : 0;

    const targetTop =
        targetEl.getBoundingClientRect().top + window.scrollY;

    const finalPosition = targetTop - topbarHeight - offset;

    const current = window.scrollY;

    const isNear = Math.abs(current - finalPosition) < 10;

    // 👉 jeśli już jesteś na miejscu → NIE rób nic
    if (isNear) return;

    const jumpPosition = finalPosition - 120;

    window.scrollTo(0, jumpPosition);

    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            smoothScrollTo(finalPosition, 450);
        });
    });
};

    // =========================
    // CLICK HANDLER
    // =========================
    const gtt = document.querySelectorAll("[data-target]");

    if (!gtt.length) return;

    const action = function (e) {
        e.preventDefault();

        const target = e.currentTarget.dataset.target;
        const offset = parseInt(e.currentTarget.dataset.offset || 0, 10);

        const exists = document.querySelector(target);

        if (exists) {
            window.runScroll(target, offset);
        } else {
            window.location.href = window.location.origin + '/' + target;
        }
    };

    gtt.forEach(el => el.addEventListener('click', action));

});